import React from "react";

import "./authWrapper.scss";

const AuthWrapper: React.FC = props => {
  return <div className="authWrapper">{props.children}</div>;
};

export default AuthWrapper;
